/** Small dependency-free helpers shared across the engine. */
export function toBytes(data) {
    if (data instanceof Uint8Array)
        return data;
    if (typeof data === 'string')
        return new TextEncoder().encode(data);
    return Uint8Array.from(data);
}
export function concatBytes(parts) {
    let total = 0;
    for (const p of parts)
        total += p.length;
    const out = new Uint8Array(total);
    let off = 0;
    for (const p of parts) {
        out.set(p, off);
        off += p.length;
    }
    return out;
}
export function toHex(bytes) {
    let s = '';
    for (const b of bytes)
        s += b.toString(16).padStart(2, '0');
    return s;
}
export function fromHex(hex) {
    const clean = hex.trim().replace(/^0x/i, '');
    if (clean.length % 2 !== 0)
        throw new Error('hex string must have even length');
    const out = new Uint8Array(clean.length / 2);
    for (let i = 0; i < out.length; i++) {
        out[i] = parseInt(clean.slice(i * 2, i * 2 + 2), 16);
    }
    return out;
}
/** Resolve the platform crypto object (Web Crypto), present in browsers and Node >=20. */
export function getCrypto() {
    const c = globalThis.crypto;
    if (!c || !c.subtle) {
        throw new Error('Web Crypto (crypto.subtle) is not available in this environment.');
    }
    return c;
}
export async function sha256(data) {
    // Copy into a fresh ArrayBuffer-backed view so digest accepts it under every
    // TS/lib version: a raw `.buffer` is `ArrayBufferLike`, which now includes
    // `SharedArrayBuffer` and is no longer assignable to `BufferSource`.
    const view = new Uint8Array(data);
    const digest = await getCrypto().subtle.digest('SHA-256', view);
    return new Uint8Array(digest);
}
/** Reads bits MSB-first from a byte stream; used to draw line values. */
export class BitReader {
    bytes;
    bitPos = 0;
    constructor(bytes) {
        this.bytes = bytes;
    }
    get remaining() {
        return this.bytes.length * 8 - this.bitPos;
    }
    readBit() {
        const byteIndex = this.bitPos >> 3;
        if (byteIndex >= this.bytes.length) {
            throw new Error('BitReader exhausted');
        }
        const bitIndex = 7 - (this.bitPos & 7);
        this.bitPos += 1;
        return (this.bytes[byteIndex] >> bitIndex) & 1;
    }
    readBits(n) {
        let v = 0;
        for (let i = 0; i < n; i++)
            v = (v << 1) | this.readBit();
        return v;
    }
}
//# sourceMappingURL=util.js.map